import React from "react";

class BulkUpdateSingleRow extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <tr role="row" id={this.props.rowId} className={(this.props.rowId % 2) ? "even" : "odd"} onClick={() => this.props.onClick(this.props.rowId)}>
                <td />
                <td><span className="text-dark font-weight-bold">{this.props.field_name}</span></td>
                <td/>
                <td/>
                <td/>
                <td>{this.props.alias}</td>
            </tr>
        )
    }
}

export default BulkUpdateSingleRow;